import React from 'react';
import AHVContext from '../../ahv-context';

export default function connect(component) {
    const nComp = (props) => {
        return (
            <AHVContext.Consumer>
                {(context) => React.createElement(component, { ...props, context })}
            </AHVContext.Consumer>
        );
    };

    nComp.displayName = `connected(${component.displayName})`;
    return nComp;
}
